/* Montgomery Sky Farm - site-specific behaviour.

   Any link pointing at #waitlist opens the Klaviyo waitlist flyout instead of
   navigating. If Klaviyo is blocked or the form does not paint, the visitor is
   sent to the inquiry form so the button is never a dead end.

   Note on the selector: Klaviyo puts the form id in data-testid, not in the
   class list, so `.klaviyo-form-VBQmq8` never matches anything. */
(function () {
  var FORM_ID = 'VBQmq8';
  var FALLBACK = '/pages/private-experiences';
  var SELECTOR = 'a[href$="#waitlist"]';
  var FORM = '[data-testid="klaviyo-form-' + FORM_ID + '"]';

  function formIsOpen() {
    var el = document.querySelector(FORM);
    if (!el) return false;
    var box = el.getBoundingClientRect();
    return box.width > 0 && box.height > 0;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest(SELECTOR);
    if (!trigger) return;
    event.preventDefault();

    if (formIsOpen()) return;

    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', FORM_ID]);
    } catch (e) {
      window.location.href = FALLBACK;
      return;
    }

    window.setTimeout(function () {
      if (!formIsOpen()) window.location.href = FALLBACK;
    }, 2500);
  });
})();

/* Any link out to the Wufoo inquiry form opens in a new tab, so the visitor
   keeps the farm site open behind it. Covers buttons, mega-menu promos,
   footer text links and anything added later in the editor. */
(function () {
  function retarget() {
    var links = document.querySelectorAll('a[href*="hiredhandsoftware.wufoo.com"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].target !== '_blank') {
        links[i].target = '_blank';
        links[i].rel = 'noopener';
      }
    }
  }
  retarget();
  document.addEventListener('DOMContentLoaded', retarget);
  new MutationObserver(retarget).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Any link to a PDF (wedding packages, waiver, brochures) opens in a new tab. */
(function () {
  function retargetPdfs() {
    var links = document.querySelectorAll('a[href$=".pdf"], a[href*=".pdf?"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].target !== '_blank') { links[i].target = '_blank'; links[i].rel = 'noopener'; }
    }
  }
  retargetPdfs();
  document.addEventListener('DOMContentLoaded', retargetPdfs);
  new MutationObserver(retargetPdfs).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Product pages booked through Appointo: reveal the "Join the list" panel under
   the booking button. Appointo loads its button from a deferred bundle, so we
   watch for it rather than checking once. If Appointo's own markup says there is
   nothing to book, the panel heading changes to say so. */
(function () {
  function init() {
  var panel = document.querySelector('[data-msf-waitlist]');
  if (!panel) return;
  if (panel.getAttribute('data-msf-waitlist-mode') === 'only') return; /* tag waitlist-only: panel is always shown, booking hidden */
  var title = panel.querySelector('[data-msf-waitlist-title]');
  var UNAVAILABLE = /no (available )?(slots?|dates?|times?)|not available|unavailable|sold out|fully booked/i;
  var shown = false;

  function appointoHandlesThisProduct() {
    try {
      var cfg = window.AppointoProductObject;
      var handle = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (!cfg || !cfg.product_details || !handle) return false;
      return cfg.product_details.some(function (p) { return p.handle === handle && p.activate && p.show_widget; });
    } catch (e) { return false; }
  }
  function check() {
    var btn = document.getElementById('appointo-btn') || document.querySelector('.appointo-btn');
    if (!btn && !appointoHandlesThisProduct()) return;
    if (!btn) { if (!shown) { panel.hidden = false; shown = true; } return; }
    if (!shown) { panel.hidden = false; shown = true; }
    var text = (btn.textContent || '').trim();
    if (title && UNAVAILABLE.test(text)) {
      title.textContent = 'No dates are open right now';
    }
  }
  check();
  var tries = 0;
  var timer = window.setInterval(function () {
    check();
    if (shown || ++tries > 40) window.clearInterval(timer);
  }, 500);
  new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
